import { Component, ViewModel, View } from "binder";
import { getAsBoolean, getAsNumber } from "../utilities";
import  { TextInputView } from "./textInput-view"

export class TextInputViewModel extends Component{
    
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.isreadonly = false;
        this.disabled = false;
        this.isnumeric=false;
        this.cancopy = false;
        this.caretposition = 0;
    }
    GetDefaultView(): View <ViewModel> {
        return new TextInputView();
    }
    public getTypeId(): string {
        return "VM-AE07F9E3-7F0F-4EF1-A7B9-5DF4D15A9234"
    }
    public set text(v: string) { this._text = v; } public get text(): string { return this._text;} private _text: string;
    public set ispassword(v: boolean) { this._ispassword = getAsBoolean(v); } public get ispassword(): boolean { return this._ispassword;} private _ispassword: boolean;
    public set isreadonly(v: boolean) { this._isreadonly = getAsBoolean(v); } public get isreadonly(): boolean { return this._isreadonly;} private _isreadonly: boolean;
    public set isnumeric(v: boolean) { this._isnumeric = getAsBoolean(v); } public get isnumeric(): boolean { return this._isnumeric;} private _isnumeric: boolean;
    public set maxlength(v: number) { this._maxlength = getAsNumber(v,true); } public get maxlength(): number { return this._maxlength;} private _maxlength: number;
    
    public set disabled(v: boolean) { this._disabled = getAsBoolean(v); } public get disabled(): boolean { return this._disabled;} private _disabled: boolean;
    public set min(v: number) { this._min = getAsNumber(v); } public get min(): number { return this._min;} private _min: number;
    public set max(v: number) { this._max = getAsNumber(v); } public get max(): number { return this._max;} private _max: number;
    public set placeholder(v: string) { this._placeholder = v; } public get placeholder(): string { return this._placeholder;} private _placeholder: string;
    public set slots(v: string) { this._slots = v; } public get slots(): string { return this._slots;} private _slots: string;
    public set accepts(v: string) { this._accepts = v; } public get accepts(): string { return this._accepts;} private _accepts: string;
    public set isshowingpassword(v: boolean) { this._isshowingpassword = getAsBoolean(v); } public get isshowingpassword(): boolean { return this._isshowingpassword;} private _isshowingpassword: boolean;
    public set cancopy(v: boolean) { this._cancopy = getAsBoolean(v); } public get cancopy(): boolean { return this._cancopy;} private _cancopy: boolean;
    public set isShowingCopiedMessage(v: boolean) { this._isShowingCopiedMessage = getAsBoolean(v); } public get isShowingCopiedMessage(): boolean { return this._isShowingCopiedMessage;} private _isShowingCopiedMessage: boolean;
    
    public set allowsuggestion(v: boolean) { this._allowsuggestion = getAsBoolean(v); } public get allowsuggestion(): boolean { return this._allowsuggestion;} private _allowsuggestion: boolean;
    public set suggestions(v: string[]) { this._suggestions = v; } public get suggestions(): string[] { return this._suggestions;} private _suggestions: string[];
    public set suggestionsseparator(v: string) { this._suggestionsseparator = v; } public get suggestionsseparator(): string { return this._suggestionsseparator;} private _suggestionsseparator: string;
    public set caretposition(v: number) { this._caretposition = v; } public get caretposition(): number { return this._caretposition;} private _caretposition: number;
    public set tabindex(v: number) { this._tabindex = v; } public get tabindex(): number { return this._tabindex;} private _tabindex: number;
    showCopiedMessage() {
        setTimeout(()=>{
            this.isShowingCopiedMessage = true;
            setTimeout(()=>this.isShowingCopiedMessage = false,3000);
    
        },500);
    }
}
